import * as React from 'react';

import {formEncodedApi} from 'nutshell-core/api';

import {colors} from 'shells/colors/colors';
import {Modal} from 'shells/modal/modal';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import {OnboardingBodyAutomations} from './onboarding-automations';
import {OnboardingBodyClosed, OnboardingGraphicClosed} from './onboarding-closed';
import {OnboardingBodyPipelines, OnboardingGraphicPipelines} from './onboarding-pipelines';
import {OnboardingBodyStages} from './onboarding-stages';
import {OnboardingBodyWelcome} from './onboarding-welcome';

type Props = {
    onClose: () => void;
    shouldShowWelcome: boolean;
};

type State = {
    currentPage: number;
};

const onboardingPages = [
    {
        body: <OnboardingBodyPipelines />,
        art: {background: colors.plum, image: <OnboardingGraphicPipelines slide='pipeline' />},
    },
    {
        body: <OnboardingBodyStages />,
        art: {background: colors.plum, image: <OnboardingGraphicPipelines slide='stage' />},
    },
    {
        body: <OnboardingBodyAutomations />,
        art: {background: colors.plum, image: <OnboardingGraphicPipelines slide='automations' />},
    },
    {
        body: <OnboardingBodyClosed />,
        art: {background: colors.plum, image: <OnboardingGraphicClosed />},
    },
];

const pagesWithWelcome = [
    {
        body: <OnboardingBodyWelcome />,
        art: {background: colors.plum, image: <OnboardingGraphicPipelines slide='welcome' />},
    },
    ...onboardingPages,
];

export class BoardOnboarding extends React.PureComponent<Props, State> {
    pageViewStartTime: Date;

    constructor() {
        // @ts-expect-error
        super();

        this.state = {
            currentPage: 0,
        };
        this.pageViewStartTime = new Date();
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeypress);

        formEncodedApi.post('/my-account/save-user-setting.json', {
            setting: 'has_viewed_onboarding_sales_automation_pipeline_NUT-9087',
            value: 1,
        });
    }

    render() {
        const pages = this.getPages();

        return (
            <div>
                <Modal
                    isOpen={true}
                    onClose={this.handleClose}
                    noPadding={true}
                    closeButton={false}
                    preventBodyScroll={false}
                    maxHeight={500}
                >
                    <OnboardingPage
                        type='multiPage'
                        // @ts-expect-error
                        bodyComponent={pages[this.state.currentPage].body}
                        // @ts-expect-error
                        artBackgroundColor={pages[this.state.currentPage].art.background}
                        // @ts-expect-error
                        artImage={pages[this.state.currentPage].art.image}
                        currentPage={this.state.currentPage}
                        pageCount={pages.length}
                        finalButtonText='Got it'
                        onNext={this.handleNextPage}
                        onGotoPage={this.handlePageChange}
                        onClose={this.handleClose}
                        onFinish={this.handleClose}
                    />
                </Modal>
            </div>
        );
    }

    handlePageChange = (newPageNum: number) => {
        this.setState({
            currentPage: newPageNum,
        });
    };

    handlePrevPage = () => {
        this.setState((prevState: State) => ({
            currentPage: prevState.currentPage - 1,
        }));
    };

    handleNextPage = () => {
        this.setState((prevState: State) => ({
            currentPage: prevState.currentPage + 1,
        }));
    };

    handleKeypress = (e: KeyboardEvent) => {
        const pages = this.getPages();
        const isFirstPage = this.state.currentPage === 0;
        const isLastPage = this.state.currentPage === pages.length - 1;
        if (e.key === 'ArrowRight' && !isLastPage) {
            this.handleNextPage();
        }

        if (e.key === 'ArrowLeft' && !isFirstPage) {
            this.handlePrevPage();
        }
    };

    handleClose = () => {
        document.removeEventListener('keydown', this.handleKeypress);

        this.props.onClose();
    };

    getPages() {
        return this.props.shouldShowWelcome ? pagesWithWelcome : onboardingPages;
    }
}
